import { DateTime } from "luxon";
import { IssuesFilterByOption, IssuesSortByOption, IssueStatus, SortByDirection } from "../../constants";
import { IssueSummaryDto } from "../../http";

export function filterIssuesFn(
  filterByOption: IssuesFilterByOption,
  filterByStatusOption: IssueStatus | undefined,
  issue: IssueSummaryDto
) {
  switch (filterByOption) {
    case IssuesFilterByOption.Status: {
      if (filterByStatusOption) {
        return issue.currentStatus === filterByStatusOption;
      } else {
        return false;
      }
    }
    case IssuesFilterByOption.All:
    default:
      return true;
  }
}

export function sortIssuesFn(
  sortByOption: IssuesSortByOption,
  sortByDirection: SortByDirection,
  a: IssueSummaryDto,
  b: IssueSummaryDto
) {
  switch (sortByOption) {
    case IssuesSortByOption.Name: {
      return sortByDirection === SortByDirection.Ascending
        ? (b.description ?? "").localeCompare(a.description ?? "")
        : (a.description ?? "").localeCompare(b.description ?? "");
    }
    case IssuesSortByOption.Upvotes: {
      const upvotesA = a.upvotes.length;
      const upvotesB = b.upvotes.length;

      return sortByDirection === SortByDirection.Ascending
        ? upvotesA > upvotesB
          ? 1
          : -1
        : upvotesA > upvotesB
        ? -1
        : 1;
    }
    case IssuesSortByOption.DateCreated: {
      const dateCreatedA = DateTime.fromISO(a.createdDateTimeUtc, { zone: "utc" }).toLocal().toMillis();
      const dateCreatedB = DateTime.fromISO(b.createdDateTimeUtc, { zone: "utc" }).toLocal().toMillis();

      return sortByDirection === SortByDirection.Ascending ? dateCreatedA - dateCreatedB : dateCreatedB - dateCreatedA;
    }
    case IssuesSortByOption.DateModified: {
      const dateModifiedA = DateTime.fromISO(a.lastModifiedDateTimeUtc, { zone: "utc" }).toLocal().toMillis();
      const dateModifiedB = DateTime.fromISO(b.lastModifiedDateTimeUtc, { zone: "utc" }).toLocal().toMillis();

      return sortByDirection === SortByDirection.Ascending
        ? dateModifiedA - dateModifiedB
        : dateModifiedB - dateModifiedA;
    }
    default:
      return 0;
  }
}
